import React, { useCallback, useEffect, useState } from "react";
import { api, extractError } from "../lib/api";
import { PageHeader } from "../components/Ui";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { toast } from "sonner";
import LabourVerificationQueue from "../components/labourWarehouse/LabourVerificationQueue";
import WarehouseStackRegister from "../components/labourWarehouse/WarehouseStackRegister";
import DailyLabourSettlement from "../components/labourWarehouse/DailyLabourSettlement";

export function labourParties(list) {
  const tagged = (list || []).filter((p) => String(p.kind || "").toUpperCase().includes("LABOUR"));
  return tagged.length ? tagged : list || [];
}

export default function LabourAndWarehouseHub() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const { data: body } = await api.get("/labour/warehouse/bootstrap");
      setData(body);
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const contractors = labourParties(data?.contractors);

  return (
    <div className="space-y-5" data-testid="labour-warehouse-hub">
      <PageHeader
        eyebrow="Mill floor"
        title="Labour & warehouse"
        description="Verify packed bags before they enter stock, keep the godown stack register, and settle the day’s piece-rate labour."
      />
      {loading && !data ? (
        <p className="text-sm text-muted-foreground">Loading the labour and warehouse register…</p>
      ) : (
        <Tabs defaultValue="verify" className="space-y-4">
          <TabsList className="bg-card border border-border p-1 h-auto flex-wrap w-full justify-start">
            <TabsTrigger value="verify">Verification queue</TabsTrigger>
            <TabsTrigger value="stacks">Stack register</TabsTrigger>
            <TabsTrigger value="settlement">Daily settlement</TabsTrigger>
          </TabsList>
          <TabsContent value="verify">
            <LabourVerificationQueue data={data} contractors={contractors} onReload={reload} />
          </TabsContent>
          <TabsContent value="stacks">
            <WarehouseStackRegister data={data} contractors={contractors} onReload={reload} />
          </TabsContent>
          <TabsContent value="settlement">
            <DailyLabourSettlement data={data} contractors={contractors} onReload={reload} />
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
}
